export default "/_next/static/chunks/fonts/Readex Pro SemiBold-1fed429b9d4485431a79d3c4eb06f82c.ttf";